import { TicketControleQuinquennalStatus as TicketControleQuinquennalStatusService } from '../service/ticket-controle-quinquennal.definition';

export type TicketControleQuinquennalStatus =
  TicketControleQuinquennalStatusService;
export const TicketControleQuinquennalStatus =
  TicketControleQuinquennalStatusService;
